// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.percentage-circle {
    position: relative;
    text-align: center;
    width: 100px;
    height: 100px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(91deg, transparent 50%, #eeeeee 50%), linear-gradient(90deg, #eeeeee 50%, transparent 50%);
}

.percentage-circle .percentage-circle-inner {
    position: relative;
    text-align: center;
    width: 90%;
    height: 90%;
    border-radius: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}

.percentage-circle .percentage-circle-inner div {
    position: relative;
    color: #212121;
}

.percentage-circle #percentage-circle-percentage {
    font-size: 22px;
    line-height: 1em;
}

@media screen and (max-width: 600px){
    .percentage-circle {
        width: 74px; height: 74px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/answer-sheet/css/circle-progress.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4HAA4H;AAChI;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW,EAAE,YAAY;IAC7B;AACJ","sourcesContent":[".percentage-circle {\n    position: relative;\n    text-align: center;\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-image: linear-gradient(91deg, transparent 50%, #eeeeee 50%), linear-gradient(90deg, #eeeeee 50%, transparent 50%);\n}\n\n.percentage-circle .percentage-circle-inner {\n    position: relative;\n    text-align: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 100%;\n    background-color: #ffffff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.percentage-circle .percentage-circle-inner div {\n    position: relative;\n    color: #212121;\n}\n\n.percentage-circle #percentage-circle-percentage {\n    font-size: 22px;\n    line-height: 1em;\n}\n\n@media screen and (max-width: 600px){\n    .percentage-circle {\n        width: 74px; height: 74px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
